<!--
 * @Author: XuXin 2172438065@qq.com
 * @Date: 2024-08-21 16:32:46
 * @LastEditors: XuXin 2172438065@qq.com
 * @LastEditTime: 2024-08-21 17:59:38
 * @FilePath: \high-tech-materialsd:\workCode\xx\youbi\front\CustPC\src\components\qrCode\qrCode.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <el-dialog
    title="提示"
    :visible.sync="dialogVisible"
    width="350px"
    append-to-body
    :before-close="handleClose"
  >
    <VueQr
      id="vueQr"
      :text="codeVal"
      :size="300"
      style="margin: 0 auto;display: block;"
    ></VueQr>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">关 闭</el-button>
    </span>
  </el-dialog>
</template>
<script>
import VueQr from "vue-qr";

export default {
  components: {
    VueQr,
  },
  data() {
    return {
      dialogVisible: false,
      codeVal: "",
    };
  },
  methods: {
    showEdit(val) {
      this.dialogVisible = true;
      this.codeVal = val;
    },
    handleClose() {
      this.dialogVisible = false;
    },
  },
};
</script>
